module.exports = __webpack_public_path__ + "img/burger-icon.8f2537ae.svg";